import script from "./BlockCreateProjectnviteEmails.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockCreateProjectnviteEmails.vue?vue&type=script&setup=true&lang=js"

import "./BlockCreateProjectnviteEmails.vue?vue&type=style&index=0&id=459750d2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-459750d2"]])

export default __exports__